import { useQuery } from '@tanstack/vue-query'
import { queries } from '@/keys'

import type { WorkingSettings } from '~/types'

export const useWorkingHours = () => {
  return useQuery({
    ...queries.settings.workingHours,
    queryFn: () => $fetch<WorkingSettings>('/api/admin/settings/hours'),
    retry: false,
  })
}
